import { config } from 'react-spring';

const animationConfig = {
  designProScreen: {
    from: {
      opacity: 1,
      transform: 'scale(1)',
    },
    enter: { transform: 'scale(1)', opacity: 1 },
    leave: { transform: 'scale(1.2)', opacity: 0 },
  },
  backgroundLogoAnimation: {
    to: { opacity: 0.8, transform: 'scale(1)' },
    from: { opacity: 0, transform: 'scale(0.9)' },
  },
  loaderAnimation: {
    to: { opacity: 1, transform: 'scale(1)' },
    from: { opacity: 0, transform: 'scale(0.5)' },
  },
  menuItemAnimation: {
    from: { opacity: 0, transform: 'translate3d(10px,0,0)' },
    to: { opacity: 1, transform: 'translate3d(0,0,0)' },
    config: config.gentle,
  },
  fadeInAnimation: {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
  },
};

// https://easings.net/#easeInOutSine
const easeInOutSine = (x: number): number => -(Math.cos(Math.PI * x) - 1) / 2;

export { animationConfig, easeInOutSine };
